<template>
  <div class="order_document_page">
    <div class="wangEditor" v-html="orderDocument"></div>
  </div>
</template>

<script>
import { getSettingApi } from "../../api/index";
export default {
  data() {
    return {
      orderDocument: ""
    };
  },
  created() { },
  activated() { },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      getSettingApi()
        .then((res) => {
          if (res.resultStatus) {
            this.orderDocument = res.resultData.orderDocument || "";
          } else {
            this.orderDocument = "";
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less">
.order_document_page {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  background: #f9fbfd;
  padding: 10px 10px 40px 10px;

  .title {
    font-size: 16px;
    color: #00a0e9;
    font-weight: 550;
    letter-spacing: 0.6px;
    margin-bottom: 26px;
  }

  .text {
    width: 100%;
    font-size: 14px;
    color: #666;
    margin-bottom: 16px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .last {
    margin-bottom: 40px;
  }
}
</style>